import React from "react";
import { Tournament } from "../../types"; 
import { Button } from "../common/Button";

type Props = {
  tournament: Tournament;
  onCreateEvent: (tournament: Tournament) => void;
};

export const TournamentCard: React.FC<Props> = ({ tournament, onCreateEvent }) => {
  return (
    <article className="w-full rounded-xl border border-gray-300 bg-white p-4 shadow-sm hover:shadow-md transition-shadow">
      {/* Header */}
      <div className="flex items-start justify-between">
        <h3 className="text-base sm:text-lg font-semibold">
          {tournament.name}
        </h3>
      </div>

      {/* Body */}
      <p className="mt-2 text-sm text-gray-600">
        Nessun evento associato a questa stagione.
      </p>

      {/* Footer */}
      <div className="grid mt-2 grid-cols-2">
        <div className="flex flex-col">
          <Button
            onClick={() => onCreateEvent(tournament)}
            variant="primary"
            size="sm"
          >
            Crea evento
          </Button>
        </div>
      </div>
    </article>
  );
};
